import React from 'react';
import moment from 'moment';
import { IDocumentItemProps } from '../../types';
import { ReactComponent as IconExport } from 'assets/images/icon-export.svg';
import { BellIcon, TrashIcon } from 'components/BorrowerTask/BorrowerTasks';
import ButtonSubmit from 'components/BorrowerTask/components/Atoms/Buttons/ButtonSubmit/ButtonSubmit';
import { StatusBadge } from 'scenes/Private/LoanList/LoanList';
import { DATE_FORMAT } from '../../../../../../@common/utils/constants/date.constants';

const DocumentItem: React.FC<IDocumentItemProps> = (props) => {
  const { 
    label, 
    docKey, 
    docId, 
    state, 
    onSelect, 
    onDelete, 
    handlerDownloadFile, 
    isDownload, 
    expiration, 
    documentCanBeDeleted 
  } = props;

  const isActionBlocked = state === 'AWAITING BORROWER' || state === 'BLOCKED';

  const onBlocking = () => {
    if (isActionBlocked) {
      props.handlerOnBlocking(props);
    }
  };

  const isExpired = moment().isAfter(moment(expiration));

  return (
    <div className={`document-item document-item-${state}`}>
      <div className='row'>
        <div className='actions-container'>
          <IconExport 
            className={!isDownload ? `disabled` : ''} 
            onClick={handlerDownloadFile} 
          />
        </div>
        <div className='label' onClick={() => onSelect({ _id: docId, key: docKey, label })}>
          {label}
          {expiration &&
            <span className={"expires-label expires-label-" + (isExpired ? 'error' : 'approved')}>
              Expires {isExpired ? 'TBD' : moment(expiration).format(DATE_FORMAT)}
            </span>
          }
        </div>
        <div className='content-right'>
          <div className='feedback-actions-container'>
            <div
              onClick={onBlocking}
              className={`action-blocked ${!isActionBlocked && 'action-blocked-disabled'} ${state === 'BLOCKED' && 'action-blocked-blocked'}`}
              style={{ paddingRight: 5 }}
            >
              <BellIcon />
            </div>
            {documentCanBeDeleted &&
              <ButtonSubmit
                onClick={() => onDelete(docId, docKey)}
                isModalToDelete={true}
                isModalToDeleteDocument={true}
                titleModal='Are you sure you want to delete this loan document? This action can not be undone'
                modalConfirm={{
                  show: true,
                }}>
                <TrashIcon />
              </ButtonSubmit>
            }
          </div>
          <div className='document-state' onClick={() => onSelect({ _id: docId, key: docKey, label })}>
            <StatusBadge title={state === 'BLOCKED' ? 'AWAITING BORROWER' : state} />
          </div>
        </div>
      </div>

      {props.boxInfo && 
        <div className='row'>
          {props.boxInfo}
        </div>
      }
    </div>
  );
};

export default DocumentItem;